import { makeStyles, tokens } from '@fluentui/react-components';
import { fontScale, mq } from '@/theme';

export const usePlannerMetricsReportScreenStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalL,
    padding: tokens.spacingVerticalXXL,
    maxWidth: '75rem',
    marginInline: 'auto',
    width: '100%',
    boxSizing: 'border-box',
    [mq.tablet]: {
      padding: tokens.spacingVerticalL,
    },
    [mq.mobile]: {
      padding: tokens.spacingVerticalM,
      gap: tokens.spacingVerticalM,
    },
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: tokens.spacingHorizontalM,
    rowGap: tokens.spacingVerticalXS,
  },
  title: {
    fontSize: fontScale.title,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
    margin: 0,
  },
  description: {
    fontSize: fontScale.body,
    color: tokens.colorNeutralForeground2,
    margin: 0,
  },
  periodsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXL,
  },
  periodBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalM,
  },
  periodHeading: {
    fontSize: fontScale.subtitle,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
    margin: 0,
  },
  tileGrid: {
    display: 'grid',
    // Mobile-first, non-overlapping breakpoints (ascending min-width so the
    // widest matching rule always wins — avoids max-width cascade ambiguity):
    // <550px → 1 card, 550–1014 → 2, 1015–1249 → 3, ≥1250 → 4.
    gridTemplateColumns: '1fr',
    gap: tokens.spacingVerticalM,
    '@media (min-width: 550px)': {
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: tokens.spacingHorizontalL,
    },
    '@media (min-width: 1015px)': {
      gridTemplateColumns: 'repeat(3, 1fr)',
    },
    '@media (min-width: 1250px)': {
      gridTemplateColumns: 'repeat(4, 1fr)',
    },
  },
  stateMessage: {
    fontSize: fontScale.body,
    color: tokens.colorNeutralForeground3,
    padding: tokens.spacingVerticalL,
  },
  loadingWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: tokens.spacingVerticalXXL,
  },
  errorMessage: {
    color: tokens.colorPaletteRedForeground1,
  },
});
